import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from 'react-fade-in'

import * as S from './form-fields-styled'

const MessageField = ({ value, onChange, isDisabled }) => (
  <FadeIn>

    <S.Label>Your Message</S.Label>

    <S.Textarea
      rows="8"
      placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      value={value}
      onChange={onChange}
      disabled={isDisabled}
    />

  </FadeIn>
)

MessageField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export { MessageField }